import Footer from 'ui/snippets/footer/Footer';
import TopRow from 'ui/snippets/topBar/TopBar';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainColumn from './MainColumn';
import MainContent from './MainContent';
import NavBar from './NavBar';
import SideBar from './SideBar';

export {
  Container,
  Content,
  MainArea,
  MainContent,
  SideBar,
  NavBar,
  MainColumn,
  Footer,
  TopRow,
};

// Container
//    TopRow
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
